<template>
	<div class="canteen2">
        <img src="../assets/shitang2.png" alt="" style="width: 100%;">
        <main>
            <p>为了进一步提升我司食堂的服务质量，确保员工的饮食健康与安全，我们特此开展本次食堂满意度及改进意见调查</p>
            <p>您的宝贵意见和建议对我们至关重要，将直接帮助我们了解食堂在运营中的优点与不足，从而有针对性地进行改进和优化</p>
            <p>请您在百忙之中抽出宝表时间，认真填写</p>
            <h3>您个人最喜爱的菜品是什么？</h3>

            <van-checkbox-group v-model="result" ref="checkboxGroup" style="margin: 0 20px; background-color: #fff;" :max="3">
                <van-checkbox :name=i+1 v-for="(item,i) in list">{{ item }}</van-checkbox>
            </van-checkbox-group>
            <br/>

            <div style="margin: 0 20px;">
                <van-field
                    v-model="value"
                    rows="6"
                    autosize
                    label="留言"
                    type="textarea"
                    maxlength="50"
                    placeholder="你最喜欢的菜品或者你对食堂的意见和建议"
                    show-word-limit
                />
            </div>
        </main>
        <br/>
        <br/>
        <footer style="padding: 0 40px;">
            <van-button type="info" size="small" @click="submit()" style="width: 100%;">提交</van-button>
        </footer>
    </div>
</template>

<script>
    import shitang from "../config/option.js"
    import { url } from '../router/api';
	export default{
        data() {
            return {
                value:'',
                result: [],
                list:shitang.shitang2
            };
        },
        methods: {
            submit() {
                if(this.value=='' && this.result.length=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请填写内容',
                    }).then(() => {});
                } else {
                    this.$dialog.confirm({
                        title: '提示',
                        message: '是否提交',
                    }).then(() => {
                        this.axios.get(url + 'complaint/caiDan', {
                            params:{
                                result:this.result.length==''?'':this.result,
                                value:this.value,
                            }
                        }).then(res=> {
                            this.$dialog.alert({
                                title: '提示',
                                message: '提交成功',
                            }).then(() => {
                                this.result = [];
                                this.value = '';
                            });
                        }).catch(err=> {});
                    }).catch(() => {});
                }
            },
        }
    }
</script>

<style scoped="cabteeb" lang='less'>
    .canteen2 {
        background-color: #E56B56;
        padding-bottom: 20px;
        main {
            padding:0 20px;
        }
        h3 {
            text-align: center;
        }
        p {
            color: #fff;
        }
        .van-checkbox {
            border-bottom: solid 1px;
            padding: 10px 0 10px 10px;
        }
    }
</style>